<template>
  <div class="pages">
    <div class="top clearfix">
      <el-button @click="onXzt" type="primary">五福</el-button>
      <p>八方来财</p>
      <el-date-picker v-model="searchDate" type="month" placeholder="选择月">
      </el-date-picker>
      <el-button type="primary" @click="onSearch">查询</el-button>
      <el-button type="primary" @click="onShowUser">用户列表</el-button>
      <el-button type="primary" @click="onStatics">统计</el-button>
      <el-button type="danger" @click="onDelete">清除本月</el-button>
      <el-button type="danger" @click="onDeleteAll">总清除</el-button>
    </div>
    <div class="tables">
      <div class="tits">
        <div class="titsLeft">
          <p>日期</p>
        </div>
        <div class="titsRight" ref="titsRight">
          <div>
            <p v-for="(item, index) in users" :key="index">
              {{ item.nickname }}
            </p>
            <p>共计-A</p>
          </div>
        </div>
      </div>

      <div class="tbody" ref="tbodyRight" @scroll="scrollEvent($event)" @touchstart="touchstart" @touchmove="touchmove"
        @touchend="touchend">
        <div class="tbodyLeft" ref="tbodyLeft">
          <div ref="tbodyLeftItem">
            <p v-for="(item, i) in maxday" :key="i">{{ i + 1 }}日</p>
            <p>共计-B</p>
          </div>
        </div>
        <div class="tbodyRight">
          <div v-for="(item, i) in maxday" :key="i" class="row">

            <template v-for="(item1, i1) in users">
              <template v-if="i1 == currentRow && i == currentColumn">
                <p :key="i1">
                  <el-input placeholder="请输入" v-model="inputData" @input="onChange" @focus="onFocus" type="text"
                    ref="input" @blur="handle(i1, i)"></el-input>
                </p>
              </template>
              <template v-else>
                <p :key="i1" @click="onClickLog(i1, i)" :class="item1.ll[i] < 0 ? 'f' : 'z'">{{ item1.ll[i] }}</p>
              </template>
            </template>

            <p :class="totalA[i] < 0 ? 'f' : 'z'">{{ totalA[i] }}</p>
            <!-- <p v-for="(item1, i1) in 16" :key="i1">{{ i + 1 }}-{{ i1 + 1 }}</p> -->
            <!-- <p  v-for="(item1, i1) in users" :key="i1">{{item1.ll[i]}}</p> -->
          </div>
          <div class="row" style="height: 41px">
            <template v-for="(zitem, zindex) in users">
              <p :key="zindex" :class="totalB[zindex] < 0 ? 'f' : 'z'">{{ totalB[zindex] }}</p>
            </template>
            <p :class="totalC < 0 ? 'f' : 'z'">{{ totalC }}</p>
          </div>
        </div>
      </div>
    </div>
    <user-list ref="userList" @sucess="onSelectUser"></user-list>
    <add-user ref="addUser" @sucess="onEditUser"></add-user>
    <s-list ref="s-list"></s-list>
  </div>
</template>

<script>
import userList from "./userlist";
import addUser from "./add_user";
import sList from './slist.vue';
export default {
  name: "tables",
  components: { userList, addUser, sList },
  data() {
    return {
      /* 移动所需参数 */
      searchDate: null,
      users: [],
      startX: 0,
      startY: 0,
      endX: 0,
      endY: 0,
      isMove: false,
      maxmonth: 12,
      maxday: 1,
      currentMonth: 1,
      currentDay: 1,
      currentRow: -1,
      currentColumn: -1,
      inputData: "",
      totalA: [],
      totalB: [],
      totalC: 0,
      change: false,
    };
  },
  created() {
    this.$nextTick(() => {
      var date = new Date();
      this.currentDay = date.getDate();
      var year = date.getFullYear();
      this.currentMonth = date.getMonth() + 1;
      this.maxday = this.getDay(year, this.currentMonth);
      this.getUser(this.currentMonth, year);

    })
  },
  methods: {

    onXzt(){
       let user = this.$store.state.user.userInfo;
       this.$router.push({ path: "/xzt", query: { name: user.username } });
    },
    onDeleteAll(){
      let self = this;
      this.$confirm('是否确认清除所有信息？', '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: '清除',
        cancelButtonText: '放弃'
      })
        .then(() => {
          self.$http.post("/admin/manager/deleteall", {}).then(res => {
              window.location.reload(true);
          });
        })
        .catch(action => {

        });
    },
    onDelete() {
      let self = this;
      this.$confirm('是否确认清除所有信息？', '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: '清除',
        cancelButtonText: '放弃'
      })
        .then(() => {
          let date = new Date(this.searchDate);
          var year = date.getFullYear();
          this.currentMonth = date.getMonth() + 1;
          self.$http.post("/admin/manager/delete", { "year": year, "month": this.currentMonth }).then(res => {
              window.location.reload(true);
          });
        })
        .catch(action => {

        });
    },
    onStatics() {

      let date = new Date();
      if (this.searchDate != null) {
        date = new Date(this.searchDate);
      }
      var year = date.getFullYear();
      this.$http.get(`/admin/manager/statistics`, { year: year }).then((res) => {
        console.log("res:", res.data);
        this.$refs["s-list"].show(res.data);
      });


    },
    onSearch() {
      let date = new Date(this.searchDate);
      var year = date.getFullYear();
      this.currentMonth = date.getMonth() + 1;
      this.maxday = this.getDay(year, this.currentMonth);
      this.getUser(this.currentMonth, year);
    },
    onShowUser() {
      this.$refs.userList.show();
    },
    onSelectUser(value) {
      this.$refs.addUser.show(value)
    },
    onChange(value) {
      console.log("value:", value);
      var ovalue = this.users[this.currentRow].ll[this.currentColumn]
      if (ovalue != value) {
        this.change = true
      }
      this.users[this.currentRow].ll[this.currentColumn] = value;
    },
    onFocus(event) {
      console.log("event:", event);
    },

    onClickLog(iindex, nnindex) {
      this.currentRow = iindex;
      this.currentColumn = nnindex;
      this.inputData = this.users[this.currentRow].ll[this.currentColumn];
      this.$nextTick(() => {
        this.$refs.input[0].focus()
      });

    },
    handle(uuindex, iindex) {
      console.log("uuindex:", uuindex, "iindex:", iindex);

      var user = this.users[uuindex];
      this.totalB[uuindex] = this.getUserLogs(uuindex);
      this.totalA[iindex] = this.getDayLogs(iindex);
      this.totalC = this.getTotal();
      var day = iindex + 1;
      var money = this.users[this.currentRow].ll[this.currentColumn];
      console.log("user:", user, "day:", day);
      if (this.change) {
        this.change = false
        this.$http
          .get(
            `/admin/manager/addlog?month=${this.currentMonth}&day=${day}&money=${money}&uid=${user.id}`
          )
          .then((res) => {
            console.log("res:", res);
          });
      }
      this.currentRow = -1;
      this.currentColumn = -1;
    },
    getDay(year, month) {
      return new Date(year, month, 0).getDate();
    },
    getTotal() {
      var val = 0;
      console.log("this.totalB:", this.totalB);
      for (var i = 0; i < this.totalB.length; i++) {
        val = val + parseInt(this.totalB[i])
      }
      return val
    },
    getUser(month, year) {
      var self = this;
      console.log("maxday:", this.maxday);
      this.$http.get(`/admin/manager/index?month=${month}&year=${year}`).then((res) => {
        if (res.code == 200) {
          self.users = res.data;
          for (var k = 0; k < self.users.length; k++) {
            self.users[k].ll = [];
            for (var i = 1; i <= self.maxday; i++) {
              self.users[k].ll[i - 1] = self.getLog(k, i);
            }
            self.totalB[k] = self.getUserLogs(k)
          }

          for (var m = 0; m < self.maxday; m++) {
            self.totalA[m] = self.getDayLogs(m);
          }
          self.totalC = self.getTotal();
        }
      });
    },
    getDayLogs(day) {
      var val = 0;
      for (var i = 0; i < this.users.length; i++) {
        var ll = this.users[i].ll[day];
        if (typeof (ll) == "string" && ll.length > 0) {
          val = val + parseInt(ll)
        }
        if (typeof (ll) == "number") {
          val = val + parseInt(ll)
        }
      }
      return val;
    },
    getUserLogs(index) {
      var user = this.users[index];
      var logs = user.ll;
      var total = 0;
      for (var k = 0; k < logs.length; k++) {
        var val = logs[k]
        if (typeof (val) == "string" && val.length > 0) {
          total = total + parseInt(val)
        }
        if (typeof (val) == "number") {
          total = total + parseInt(val)
        }
      }
      return total;
    },
    getLog(index, day) {
      var user = this.users[index];
      var logs = user.logs;
      for (var k = 0; k < logs.length; k++) {
        var v = logs[k];
        if (parseInt(v.day) == day) {
          return v.money;
        }
      }
      return "";
    },
    scrollEvent(e) {
      this.$refs.titsRight.style.left = -e.target.scrollLeft + 80 + "px";
      this.$refs.tbodyLeftItem.style.top = -e.target.scrollTop + "px";
    },

    /* 监听滑动开始 */
    touchstart(e) {
      /* 阻止一些默认事件 */
      // e.preventDefault();
      /* 记录初始位置 */
      this.startX = e.touches[0].pageX;
      this.startY = e.touches[0].pageY;
      console.log(this.startX, this.startY);
    },
    /* 监听滑动移动 */
    touchmove(e) {
      /* 判断是否滚动 */
      this.isMove = true;
      /* 监听滑动最终结束的位置 */
      this.endX = e.touches[0].pageX;
      this.endY = e.touches[0].pageY;

      /* 判断移动方向 */
      let X = this.endX - this.startX,
        Y = this.endY - this.startY;
      /* 判断是否移动还是点击 */
      if (this.isMove) {
        if (X > 0 && Math.abs(X) > Math.abs(Y)) {
          //向右
          console.log("向右");
          this.$refs.tbodyRight.style["overflowY"] = "hidden";
          this.$refs.tbodyRight.style["overflowX"] = "auto";
        } else if (X < 0 && Math.abs(X) > Math.abs(Y)) {
          //向左
          console.log("向左");
          this.$refs.tbodyRight.style["overflowY"] = "hidden";
          this.$refs.tbodyRight.style["overflowX"] = "auto";
        } else if (Y > 0 && Math.abs(Y) > Math.abs(X)) {
          //向下
          console.log("向下");
          this.$refs.tbodyRight.style["overflowX"] = "hidden";
          this.$refs.tbodyRight.style["overflowY"] = "auto";
        } else if (Y < 0 && Math.abs(Y) > Math.abs(X)) {
          //向上
          console.log("向上");
          this.$refs.tbodyRight.style["overflowX"] = "hidden";
          this.$refs.tbodyRight.style["overflowY"] = "auto";
        } else {
          //没有
          // console.log("没有");
        }
      } else {
        // console.log("没有");
      }
    },
    touchend(e) { },
  },
};
</script>
<style scoped lang="less">
@twidth: 80px;
@theight: 26px;

::-webkit-scrollbar {
  /*隐藏滚轮*/
  display: none;
}

* {
  margin: 0;
  padding: 0;
}

p {
  width: @twidth;
  height: @theight;
  text-align: center;
  line-height: @theight;
  flex-shrink: 0;
}

.top {
  height: 40px;
  width: 100%;
  background: blue;
  padding: 5px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;

  .el-date-editor {
    height: 30px;
    margin-right: 10px;
  }

  /deep/.el-input__inner {
    height: 30px;
  }

  p {
    flex: 1;
    color: white;
    font-size: 20px;
    letter-spacing: 20px;
  }

  .el-button {
    float: right;
    margin-right: 20px;
    padding: 5px 10px;
  }
}

.tables {
  width: 100%; //自定义表格整体宽度
  font-size: 12px;
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  position: relative;
  border-right: 1px solid red;

  // border-bottom: 1px solid red;
  // border-bottom: 1px solid #ccc;
  .tbody {
    height: calc(100vh - 100px); //自定义表格内容高度
    overflow: auto;
  }

  >div {
    display: flex;
  }

  div {
    flex-shrink: 0;
  }

  .tits {
    height: @theight;
    padding-left: @twidth;
    background-color: #fff;
  }

  .titsLeft,
  .tbodyLeft {
    width: @twidth;
  }

  .titsRight,
  .tbodyRight {
    width: 250px; //自定义表头表体内容宽度
  }

  .titsLeft {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 100;

    p {
      width: @twidth;
      background-color: #fff;
      border-bottom: 1px solid #999;
    }
  }

  .titsRight {
    height: @theight;
    position: absolute;
    top: 0;

    div {
      display: flex;
      right: 17px;

      p {
        background-color: #fff;
        font-weight: bold;
        color: orangered;
        background: #ededed;
        border-left: 1px solid #999;
        border-bottom: 1px solid #999;

        &:last-child {
          border-right: 1px solid #999;
        }
      }
    }
  }

  .tbodyLeft {
    // overflow: hidden;
    white-space: nowrap;
    height: 100%;
    background-color: #fff;

    div {
      margin-top: @theight;
      width: @twidth;
      background-color: #fff;
      left: 0;
      top: 0px;
      position: absolute;
      overflow: hidden;

      p {
        color: black;
        font-weight: bold;
        border-bottom: 1px solid #999;
      }

      // padding-top: 40px;
      // bottom: 17px; //避开下方滚动条位置
    }
  }

  .tbodyRight {
    white-space: nowrap;
    background-color: none;
    display: flex;
    flex-direction: column;

    .row {
      display: flex;

      p {
        border-left: 1px solid #999;

        border-bottom: 1px solid #999;

        &:last-child {
          border-right: 1px solid #999;
        }

        &.z {
          color: blue;
        }

        &.f {
          color: red;
        }
      }
    }
  }
}</style>



